import {
  VisualizationDataTableFilterControlType as ControlType,
  VisualizationDataTableFilterLayoutType as LayoutType,
  VisualizationDataTableFilterType
} from "~/enums/visualizations/visualizationDataTableFilterType";

export default class VisualizationDataTableFilterDefinition {
  private constructor() {}

  static definitions: { [key in VisualizationDataTableFilterType]: {displayName: string, icon: string, workareaComponent: string, filterComponent: string, class: string} } = {
    [ControlType.Dropdown]: {
      displayName: 'Dropdown',
      icon: 'dropdown',
      workareaComponent: 'filter-element-dropdown',
      filterComponent: 'filter-dropdown',
      class: 'vdt-filter-dropdown',
    },
    [ControlType.SearchBar]: {
      displayName: 'Search Bar',
      icon: 'search-bar',
      workareaComponent: 'filter-element-search-bar',
      filterComponent: 'filter-search-bar',
      class: 'vdt-filter-search-bar',
    },
    [ControlType.DateRange]: {
      displayName: 'Date Range',
      icon: 'date-range',
      workareaComponent: 'filter-element-date-range',
      filterComponent: 'filter-date-range',
      class: 'vdt-filter-date-range',
    },
    [ControlType.Toggle]: {
      displayName: 'Toggle',
      icon: 'toggle',
      workareaComponent: 'filter-element-toggle',
      filterComponent: 'filter-toggle',
      class: 'vdt-filter-toggle',
    },

    [LayoutType.Grid]: {
      displayName: 'Grid',
      icon: 'grid',
      workareaComponent: 'filter-element-grid',
      filterComponent: 'filter-grid',
      class: 'vdt-filter-grid',
    },
    [LayoutType.Stack]: {
      displayName: 'Stack',
      icon: 'stack',
      workareaComponent: 'filter-element-stack',
      filterComponent: 'filter-stack',
      class: 'vdt-filter-stack',
    },
  };

  static getDisplayName(type: VisualizationDataTableFilterType): string {
    return this.definitions[type].displayName;
  }

  static getIcon(type: VisualizationDataTableFilterType): string {
    return this.definitions[type].icon;
  }

  static getWorkareaComponent(type: VisualizationDataTableFilterType): string {
    return this.definitions[type].workareaComponent;
  }

  static getFilterComponent(type: VisualizationDataTableFilterType): string {
    return this.definitions[type].filterComponent;
  }

  static getClassName(type: VisualizationDataTableFilterType): string {
    return this.definitions[type].class;
  }

  static get controlElements(): Array<{name: string, icon: string, type: ControlType}> {
    return [
      ControlType.Dropdown,
      ControlType.SearchBar,
      ControlType.DateRange,
      ControlType.Toggle,
    ].map((type) => {
      return {
        name: this.getDisplayName(type),
        icon: this.getIcon(type),
        type,
      };
    });
  };

  static get layoutElements(): Array<{name: string, icon: string, type: LayoutType}> {
    return [
      LayoutType.Grid,
      LayoutType.Stack,
    ].map((type) => {
      return {
        name: this.getDisplayName(type),
        icon: this.getIcon(type),
        type,
      };
    });
  };
}